
























import Vue, { PropType } from 'vue';
import { ConfirmationModalData } from '@/types';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'ConfirmationModal',
  data () {
    return {
      EventType
    }
  },
  props: {
    modalData: {
      type: Object as PropType<ConfirmationModalData>,
      required: true
    },
    hideActions: {
      type: Boolean,
      default: false
    }
  }

})
